import { auth } from "./firebase";

const BASE = import.meta.env.VITE_API_BASE_URL as string;

export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
  ) {
    super(message);
  }
}

/** Authenticated REST client; money/booking POSTs get an Idempotency-Key. */
export async function api<T>(
  path: string,
  options: { method?: string; body?: unknown; idempotent?: boolean } = {},
): Promise<T> {
  const token = await auth.currentUser?.getIdToken();
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (options.idempotent) headers["Idempotency-Key"] = crypto.randomUUID();

  const response = await fetch(`${BASE}/v1${path}`, {
    method: options.method ?? (options.body ? "POST" : "GET"),
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = (json as { error?: { code: string; message: string } }).error;
    throw new ApiError(err?.code ?? "INTERNAL", err?.message ?? "Request failed");
  }
  return json as T;
}
